// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__yspQ1","logo":"styles_logo__pM4fu"};